import './style.css'
import ReactDOM from 'react-dom/client'
import { ExperienceXR } from './ExperienceXR'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<ExperienceXR />)